module.exports = __webpack_public_path__ + "img/Staff Group.7f97ed55.svg";